export default __webpack_public_path__ + "static/media/todo2.52b49e94.png";